// src/pages/ContinueInApp.js
// v5 – clearer web-completion fallback story
//
// Changes vs v4:
// ✅ Reframes this as the post-web-completion continuation path
// ✅ Clarifies app-installed vs install-needed next steps
// ✅ Keeps one clear next action without implying this is the only activation story
// ✅ Reinforces that future sign-in uses the same email/password just created

import React from "react";
import { useLocation, Link } from "react-router-dom";
import QRCode from "react-qr-code";

import { ROUTES, MOBILE_APP_INSTALL_URL } from "../config";
import "../styles/ContinueInApp.css";

const ContinueInApp = () => {
  const location = useLocation();
  const emailFromState = location.state?.email || "";
  const roleFromState = String(location.state?.role || "").toUpperCase();
  const isPrincipal = roleFromState === "PRINCIPAL";

  const heroTitle = "Your account is ready";
  const heroSubtitle = isPrincipal
    ? "You’ve finished setting up your account on the web. Next, open the GhrianGhraffy App on your phone to finish setting up your school."
    : "You’ve finished setting up your account on the web. Next, open the GhrianGhraffy App on your phone and sign in with your new staff account.";
  const noteText = isPrincipal
    ? "Use the same email address and password you just created."
    : "Use the same email address and password you just created.";
  const cardTitle = isPrincipal ? "Sign in with these details" : "Sign in with these details";

  return (
    <div className="continue-in-app-page">
      <div className="continue-in-app-shell">
        <div className="continue-in-app-hero">
          <div className="continue-in-app-badge">Ready to go</div>
          <h1 className="continue-in-app-title">{heroTitle}</h1>

          <p className="continue-in-app-subtitle">{heroSubtitle}</p>

          <a
            className="continue-in-app-button primary"
            href={MOBILE_APP_INSTALL_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            Open install page
          </a>

          <p className="continue-in-app-note">{noteText}</p>
        </div>

        <section className="continue-in-app-card">
          <h2 className="continue-in-app-card-title">{cardTitle}</h2>

          <div className="continue-in-app-credential-box">
            <div className="continue-in-app-credential-row">
              <div className="continue-in-app-credential-label">Email</div>
              <div className="continue-in-app-credential-value">
                {emailFromState || "Your registered email"}
              </div>
            </div>

            <div className="continue-in-app-credential-row">
              <div className="continue-in-app-credential-label">Password</div>
              <div className="continue-in-app-credential-value">The password you just created</div>
            </div>
          </div>
        </section>

        <section className="continue-in-app-card">
          <h2 className="continue-in-app-card-title">Next on your phone</h2>
          <p className="continue-choice-helper">
            If the GhrianGhraffy App is already installed, open it and sign in.
            If not, open the install page on your phone, or scan this code with your phone camera.
          </p>

          <div className="continue-in-app-footer-actions" style={{ marginBottom: 20 }}>
            <a
              className="continue-in-app-button primary"
              href={MOBILE_APP_INSTALL_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Open install page
            </a>

            <Link className="continue-in-app-button secondary" to={ROUTES.LOGIN}>
              Back to Login
            </Link>
          </div>

          <div className="continue-in-app-qr-frame">
            <QRCode value={MOBILE_APP_INSTALL_URL} size={150} />
          </div>
        </section>
      </div>
    </div>
  );
};

export default ContinueInApp;